import React from 'react';

export const ColoradoInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">City of Denver</p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business Emergency Relief Program</strong> |&nbsp;
            <a
                href="https://www.denvergov.org/content/denvergov/en/environmental-health/news/coronavirus-info/support-services/small-business-emergency-relief-program-form.html"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>Cash grants up to $7,500 to qualifying small businesses.</p>

        <p className="eds-l-mar-bot-1 eds-l-mar-top-4">
            <strong>Microloan Program</strong> |&nbsp;
            <a
                href="https://www.denvergov.org/content/denvergov/en/denver-office-of-economic-development/build-your-business/financing.html"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Existing microloan program to support small businesses’
            stabilization efforts. Current recipients of loans from DEDO will
            have the ability to temporarily defer loan payments
        </p>
    </div>
);
